export const GROUP = {
  academicTitle: "ACADEMIC_TITLE",
  academicDiscipline: "ACADEMIC_DISCIPLINE",  
  activityType: "ACTIVITY_TYPE",
  activity:"ACTIVITY",
  countriesResearchFieldWithAcademic: "COUNTRIES_RESEARCH_FIELD_WITH_ACADEMIC",
  courseType: "COURSE_TYPE",
  courseSubtype: "COURSE_SUBTYPE",
  courseSubtypeESR: "COURSE_SUBTYPE_ESR",
  courseCycle: "COURSE_CYCLE",
  courseTitle: "COURSE_TITLE", 
  courseFormat: "COURSE_FORMAT",     
  disciplineFieldWithAcademic: "DISCIPLINE_FIELD_WITH_ACADEMIC",  
  expertiseField: "EXPERTISE_FIELD",
  expertiseFieldWithAcademic: "EXPERTISE_FIELD_WITH_ACADEMIC",
  gender: "GENDER",
  keyword: "KEYWORD",
  language: "LANGUAGE",
  linksType: "LINK_TYPE",
  logo:"LOGO",    
  opportunityType: "OPPORTUNITY_TYPE",
  period: "PERIOD",  
  researchCenterUniversity: "RESEARCH_CENTER_UNIVERSITY",
  researchCenterUniversityWithAcademic: "RESEARCH_CENTER_UNIVERSITY_WITH_ACADEMIC",
  researchCountry: "RESEARCH_COUNTRY",
  researchProject: "RESEARCH_PROJECT",
  roleGroup: "ROLE_GROUP",
  role: "ROLE",  
  sessionFormat: "SESSION_FORMAT",  
  teacher: "TEACHER",
  teacherVisible: "TEACHER_VISIBLE",
  title: "TITLE",
  topic: "TOPIC",
  topicFull: "TOPIC_FULL",
  userRoleGroupName: "USER_ROLE_GROUP_NAME",
  university: "UNIVERSITY",
  universityAll: "UNIVERSITY_ALL",
  universityAllWithAcademic: "UNIVERSITY_ALL_WITH_ACADEMIC",
  universityUnit: "UNIVERSITY_UNIT",  
  workingLanguageFieldWithAcademic: "WORKING_LANGUAGE_FIELD_WITH_ACADEMIC",
  workingLanguage: "WORKING_LANGUAGE"  
};

export const COURSE_TYPE = {
  additional: "ADDITIONAL",
  esr: "ESR",
  europeanWeek: "EUROPEAN_WEEK",
  honourSeminar: "HONOUR_SEMINAR",
  joint: "JOINT",
  multi: "MULTI",
  open: "OPEN",
  other: "OTHER",
  summerSchool: "SUMMER_SCHOOL", 
  workshop: "WORKSHOP"
};

export const OPPORTUNITY_TYPE = {
  alert: "ALERT",
  home: "HOME",
  news: "NEWS"
};


export const PUBLIC_PROFILE = {
  student: "STUDENT",
};
